import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "TroubleShooting",
  "menu": "Guides",
  "route": "/guides/trouble-shooting",
  "description": "Trouble-shooting section. Might find what you are looking for here."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`TroubleShooting`}</h1>
    <h2>{`Module not found: Can't resolve 'styled-components'`}</h2>
    <p>{`If you encounter the error `}<inlineCode parentName="p">{`Module not found: Can't resolve 'styled-components' in [...]`}</inlineCode>{` it probably means that you
need to install the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/styled-components"
      }}>{`styled-components`}</a>{` library in your project as stated
in the `}<a parentName="p" {...{
        "href": "/#get-started"
      }}>{`Get Started guide`}</a>{`.`}</p>
    <p>{`Indeed, `}<strong parentName="p">{`components-extra`}</strong>{` relies on `}<em parentName="p">{`styled-components`}</em>{` for its styling system. It is not included in the bundle in
order to prevent any duplicated instance of `}<em parentName="p">{`styled-components`}</em>{` in your final bundle.`}</p>
    <h2>{`Module not found: Can't resolve '@material-ui/core'`}</h2>
    <p>{`If you encounter the error `}<inlineCode parentName="p">{`Module not found: Can't resolve '@material-ui/core' in [...]`}</inlineCode>{` it probably means that you
need to install the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@material-ui/core"
      }}>{`@material-ui/core >= 4.0.0`}</a>{` library in your project as stated
in the `}<a parentName="p" {...{
        "href": "/#get-started"
      }}>{`Get Started guide`}</a>{`.`}</p>
    <p>{`Indeed, all the components are built on top of Material-UI.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      